import React, { FC } from 'react';
import { BaseCell } from 'components/organisms/timesheets/common/timesheet-table';

export const NumberCell: FC<{ value?: number }> = ({ value }) => (
  <BaseCell>{value != null ? value : '-'}</BaseCell>
);
